import {Component, Input} from '@angular/core';
import {SubscriberMelody} from "../../model/subscriber-melody";
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";

@Component({
  selector: 'app-delete-melody-modal',
  templateUrl: './delete-melody-modal.component.html',
  styleUrls: ['./delete-melody-modal.component.css']
})
export class DeleteMelodyModalComponent {
  @Input() melody: SubscriberMelody;
  deleteInProgress: boolean;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService) {
    this.deleteInProgress = false;
  }

  close(): void {
    this.modalsService.hideModal();
  }

  deleteMelody(): void {
    this.subscriberService.deleteMelody(this.melody);
    this.deleteInProgress = true;
  }
}
